export const email={label:"邮箱"};
export const SMS={label:"SMS"};
export const sendOTP={label:"发送OTP"};
export const login={label:"登 录"};




export const canNotLogin="不能登录，请联系总部。";
export const referenceNotFound="申请编号不存在。";
export const enterOTP="请输入OTP";
export const after="重新发送 ";
export const second="秒";


export const trackStatus="申请状态追踪";
export const enterReference="请输入申请编号";
export const track="追踪";
export const accreditedSuppliers="合格供应商";
export const softwareIntegrators="软件集成商";
export const devices="设备";
export const download="下载";
export const application="应用软件";
export const documents="文档";
export const username ="登录 ID";
export const enterUsername ="请输入账号";
export const captcha ="验证码";
export const enterCaptcha ="请输入验证码";
export const pwd ="密码";
export const enterPwd ="请输入密码";
export const OTPMethod ="OTP发送方式";
export const mobile ="当前电话号码";
export const forgetPwd ="忘记密码";
export const noAccount ="没有账号？";
export const registerNow ="马上注册";

export const note ="注意：请始终将OTP保存在安全可靠的位置。";
export const moreDetails ="更多";
export const prompt ="提示";
export const back ="返回";
export const howToProtect ="如何保护OTP和业务信息。";

export const no1 ="i.不要通过电话或在线披露您的OTP。";
export const no2 ="ii.切勿向任何人透露您的OTP。甚至是你身边的人。";
export const no3 ="iii.不要把OTP放在钱包或口袋里的一张纸上。";
export const no4 ="iv.不要在别人可以看到的地方写下你的OTP。";
export const no5 ="v.登录时不要让计算机或移动小工具无人看管。";
export const no6 ="vi.保护您的业务和个人信息";
export const no7 ="vii.如果您怀疑您的OTP被泄露，请立即通知税务机关。 ";

export const modifyPassword ="修改密码";
export const pleaseLogin ="请登录！";
export const downloadDocuments ="下载文档";
export const forgetPassword ="忘记密码";
export const newPassword ="新密码";
export const oldPassword="旧密码";
export const confirmPassword ="确认密码";
export const enterEmail = "请输入邮箱";
export const modifyPasswordCancel="您确定要取消吗？单击确定，您将退出系统。";
export const passwordSuccessfullyChangedPleaseReLogin="密码更改成功！请重新登录。";

export const no={label:"序号"};
export const softwareName={label:"软件名称"};
export const size={label:"大小"};
export const type={label:"类型"};
export const lastDate={label:"更新日期"};
export const downloadTimes={label:"下载次数"};
export const allName={label:"操作"};

export const setting="设置";
export const emailSetting = "你想以买家的身份在邮件中收到发票通知吗？";
export const taxCalculationSetting = "你使用哪种税收计算方法？";

export const accountSecurity ="账户安全";
export const enableAuthorizeCode="启用授权登录";
export const authorizeCode="生成授权码";
export const generate = "生成";
export const generateTime = "生成时间";
export const securityDescription="点击“生成”按钮重新生成授权码，现有授权码将自动失效。";

